/**
 *
 * EditMarker
 *
 */

import React from 'react';
import PropTypes from 'prop-types';

import DraggableCircleMarker from 'components/DraggableCircleMarker';
import withEdit from 'containers/EditService/withEdit';
import getSnap from 'utils/getSnap';
import PopupMenu from 'components/PopupMenu';
import { LEG_FIRST, LEG_LAST } from '../constants';
import messages from './messages';

/* eslint-disable react/prefer-stateless-function */
class EditMarker extends React.PureComponent {
  constructor(props) {
    super(props);
    this.getClassName = this.getClassName.bind(this);
  }

  addPoint(pos) {
    const { travelMode, addPoint } = this.props;
    addPoint(pos, travelMode);
  }

  deletePoint() {
    const { leg, travelMode, deletePoint } = this.props;
    deletePoint(leg.id, travelMode);
  }

  getClassName() {
    const { type } = this.props;
    if (type === LEG_LAST) {
      return 'edit-icon-end';
    }
    if (type === LEG_FIRST) {
      return 'edit-icon-start';
    }
    return 'edit-icon-default';
  }

  handleDragend = ev => {
    const { leg, onDrag } = this.props;
    onDrag(null);
    const { movePoint, travelMode } = this.props;
    const snap = getSnap(ev.target.options.leaflet.map);
    movePoint(leg.id, { ...ev.target.getLatLng(), snap }, travelMode);
  };

  handleDrag = ev => {
    const { onDrag, leg } = this.props;
    onDrag({ legId: leg.id, latlng: ev.latlng, isMarker: true });
  };

  handleClick = item => pos => this[item](pos);

  render() {
    const { leg, type } = this.props;
    const disabled = type === LEG_LAST ? ['addPoint'] : [];
    return (
      <DraggableCircleMarker
        key={`c_${leg.id}`}
        center={leg.lastPoint}
        draggable
        className={this.getClassName()}
        onDragend={this.handleDragend}
        onDrag={this.handleDrag}
      >
        <PopupMenu
          items={['addPoint', 'deletePoint']}
          messages={messages}
          disabled={disabled}
          onClick={this.handleClick}
        />
      </DraggableCircleMarker>
    );
  }
}

EditMarker.propTypes = {
  leg: PropTypes.object.isRequired,
  type: PropTypes.number,
  travelMode: PropTypes.string.isRequired,
  movePoint: PropTypes.func.isRequired,
  addPoint: PropTypes.func.isRequired,
  deletePoint: PropTypes.func.isRequired,
  onDrag: PropTypes.func.isRequired,
};

export default withEdit(EditMarker);
